import type { SbBlokData } from '@storyblok/react'
import { storyblokEditable as sbEditable } from '@storyblok/react'

export function storyblokEditable(blok: SbBlokData) {
  const editProps = sbEditable(blok)

  if (typeof blok.commonLinkAnchor === 'string') {
    return { ...editProps, id: blok.commonLinkAnchor }
  }

  return editProps
}
